<template>
  <div :class="headerClasses">
    <div :class="style.header">
      <slot>
        <span>
          {{ text }}
        </span>
      </slot>
      <ButtonIcon v-if="icon !== 'transparent'" :icon="icon" />
    </div>
  </div>
</template>

<script lang="ts">
import style from "../Dropdown.module.scss";
import {defineComponent, PropType} from "vue";
import IconBase from "@/elements/UI/icon/IconBase.vue";
import ButtonIcon from "@/elements/UI/button/ButtonIcon/ButtonIcon.vue";

export default defineComponent({
  name: "DropdownHeader",
  components: {ButtonIcon, IconBase},
  props: {
    text: {
      type: String,
      default: ""
    },
    size: {
      type: String as PropType<Size>,
      default: "S"
    },
    index: {
      type: Number,
      default: 0
    },
    maxSize: {
      type: Number,
      default: 0
    },
    icon: {
      type: String,
      default: "transparent"
    }
  },
  data() {
    return {
      style
    };
  },
  computed: {
    positionClass(): string {
      if (this.maxSize <= 1) {
        return style.single;
      }

      if (this.index === 0) {
        return style.first;
      }

      if (this.index === this.maxSize - 1) {
        return style.last;
      }

      return style.middle;
    },
    headerClasses() {
      return [style.dropdown, style[`size${this.size}`], this.positionClass];
    }
  }
});
</script>
